import API from "./api";
import store from "../store/";
import ConfigAPI from "./config";
function getFollowers() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/followers/${channelId}?username=`+ ConfigAPI.getUsername()
  return API.get(url);
}

function getFollowerButtonEvents() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/followers-button/${channelId}`
  return API.get(url);
}

function getFollowersTarget(followers) {
  var config = Twitch.ext.configuration;
  if (config.broadcaster) {
    var broadcaster = JSON.parse(config.broadcaster.content);
    return broadcaster.followers.target;
  }

  return followers + 1;
}

function followChannel() {
  const { channelId } = store.state;
  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }
  Twitch.ext.actions.followChannel(ConfigAPI.getUsername());
}

function userFollowed(channelName) {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/user-followed/${channelId}`;
  return API.post(url, null, {
    params: {
      username: channelName
    }
  });
}

function isUserFollowing() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/user-follows/${channelId}`;
  return API.get(url);
}

export default {
  userFollowed,
  getFollowers,
  getFollowersTarget,
  getFollowerButtonEvents,
  followChannel,
  isUserFollowing
};
